import {DocumentAuditSaveRequestPayload} from '../api/types/reportingApi.type';

/**
 * Transforms DocumentAuditSaveRequestPayload for the /document-audit/save  and  /sharereports/report-xml endpoint.
 * 
 * This function renames certain parameters to prevent 
 * the Document Audit report grid from appearing empty.
 * 
 * Note: While modifying the model in AuroraReview.Api.Reporting would be a cleaner solution,
 * this transformation approach was chosen to avoid potential defects in the Sightline Legacy code.
 */

export const transformToSaveReportPayload = (payload: any): any => {
  // Check if this payload has selected_ActionTypeID
  if (!payload || typeof payload !== 'object') {
    return payload;
  }
  
  let transformedPayload = {...payload};

  // selected_ActionTypeID -> SelectedActionTypeID
  if ('selected_ActionTypeID' in transformedPayload) {
    const {selected_ActionTypeID, ...rest} = transformedPayload;
    transformedPayload = {
      ...rest,
      SelectedActionTypeID: selected_ActionTypeID,
    };
  }

  // selected_UserID -> SelectedUserID
  if ('selected_UserID' in transformedPayload) {
    const {selected_UserID, ...rest} = transformedPayload;
    transformedPayload = {
      ...rest,
      SelectedUserID: selected_UserID,
    };
  }
  
  return transformedPayload;
};